
import auth from "@/router/middlewares/auth"
import MainView from "@/components/layout/main-view"
import DnsList from "@/components/dns/dns-list"
import DnsSingle from "@/components/dns/dns-single"


export default [

    {
        path:'/dns',
        name:'dns-view',
        component:MainView,
        meta:{
            middleware:auth,
            "package":'dns',
            "key":'dns'
        }

    },

    {
    path:'/dns/list',
    name:'dns-list',
    component:DnsList,
    meta:{
      middleware:auth,
      "package":'dns',
      "key":'dns'
    }

  },
  {
    path:'/dns/zone/:name',
    name:'dns-single',
    component:DnsSingle,
    meta:{
      middleware:auth,
      "package":'dns',
      "key":'dns'
    }

  }
]



// WEBPACK FOOTER //
// ./src/router/routes/dns/index.js